'use strict';

module.exports = function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/dom-helpers/style/removeStyle.js
// module id = 5578
// module chunks = 0